import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import Avatar from '@/components/avatar/Index.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import FormHeader from '@/components/v2/FormHeader.vue';
import Orders from '@/components/v2/ecommerce/OrderHistory';
import PageTitle from '@/components/v2/PageTitle.vue';
import Paginator from '@/components/v2/Paginator.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import TheOrderDetailsDialog from '@/components/v2/ecommerce/TheOrderDetailsDialog.vue';
import OrderDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/OrderDetailsMixin';
import TodaysOrderCount from '@/components/v2/ecommerce/TodaysOrderCount';
import LinkButton from '@/components/link_button/Index.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
let OrderHistory = class OrderHistory extends Mixins(OrderDetailsMixin, ViewportSizeMixin, RouterParamsAppMixin, CleverTapEventsMixin, PaginatorMixin) {
    constructor() {
        super(...arguments);
        this.fallbackPhotoUrl = require('@/assets/images/cg_logo.png');
    }
    get headers() {
        return [
            {
                text: 'REFERENCE ID',
                value: 'transactionNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PRODUCT PHOTO',
                value: 'productPhoto',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PRODUCT NAME',
                value: 'productName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOMER NAME',
                value: 'customerName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'AMOUNT',
                value: 'amount',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PAYMENT METHOD',
                value: 'customerName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ORDER DATE',
                value: 'date',
                align: 'left',
                sortable: false,
            },
        ];
    }
    propItemImage(prop) {
        if (process.env.NODE_ENV === 'development') {
            return this.fallbackPhotoUrl;
        }
        return prop.item.order.firstItem.productPrimaryPhoto || '';
    }
    /**
     * Mounted Hook for filtering history by transaction number
     * @author Peter John Alvarado
     * @since Version 0.1.10
     *
     * @return { void }
     */
    mounted() {
        this.viewOrdersHistory();
        const route = this.$router.currentRoute;
        const { txn } = route.query;
        if (txn) {
            const vm = this;
            vm.$refs.search.setValue(txn);
            vm.$refs.orders.onSearch(txn);
        }
    }
};
OrderHistory = __decorate([
    Component({
        components: {
            Avatar,
            ActionButton,
            BaseAnalyticsBannerContent,
            BaseSearchInput,
            BaseOverlayLoader,
            FormHeader,
            Orders,
            PageTitle,
            Paginator,
            TheOrderDetailsDialog,
            TodaysOrderCount,
            LinkButton,
        },
    })
], OrderHistory);
export default OrderHistory;
